export default __webpack_public_path__ + "static/media/askCameraAccess.242f4da9.png";